<template src="./index.html"></template>
<script>
import minhead from '../../../../common/minHead/index.vue';
import SalesTaxReportTree from '../../../../common/SalesTaxReportTree/index.vue';
import SalesTaxReportbox from '../../../../common/SalesTaxReportbox/index.vue';
import { getdata } from './data.js';
import config from '../../../../../../configHttp.js';
import uploadFile from '../../../../common/uploadFile/index.vue';
import uploadFileplus from '../../../../common/uploadFileplus/index.vue';
import {
	querycell,
	writesave,
	startShenBao,
	forShengcdg,
	manuscriptqueryReportStep,
	manuscriptwriteimport,
	manuscriptUploadFile,
	annexadd
} from '../../../../../api/Draftgeneration.js';
import { querytemplatecell, getShuibDetailList, templatecellsave } from '../../../../../api/bbmb.js';
import { reportquerytrack } from '../../../../../api/xggj.js';
import { zcfg_fycx, zcfg_fetch } from '../../../../../api/zcfg.js';
import addzc from '../../../../common/addzc/index.vue';
import seezc from '../../../../common/seezc/index.vue';
import TaxableService_I from './TaxableServiceI/index.vue';
import TaxableService_II from './TaxableServiceII/index.vue';
import { getdata as getdataI } from './TaxableServiceI/data.js';
import { getdata as getdataII } from './TaxableServiceII/data.js';
export default {
	name: '',
	components: {
		minhead,
		SalesTaxReportTree,
		SalesTaxReportbox,
		uploadFile,
		uploadFileplus,
		addzc,
		seezc,
		TaxableService_I,
		TaxableService_II
	},
	props: {
		type: {
			type: String,
			default: ''
		},
		params: {
			type: Object,
			default: {}
		},
		sbqj: {
			type: String,
			default: ''
		},
		showbox: {
			type: Boolean,
			default: false
		},
		mintext: {
			type: String,
			default: '填写'
		},
		toseeUpdate: {
			type: Boolean,
			default: false
		},
		seeNow: {
			type: Boolean,
			default: false
		},
		suosq: {
			type: String,
			default: ''
		}
	},
	mounted() {
		if (this.toseeUpdate) {
			this.getShuibDetailList();
		} else {
			this.manuscriptqueryReportStep();
		}
	},
	data: function() {
		return {
			Changed:0,
			treestate: '',
			statedata: [],
			treedata: getdata().treedata,
			choosetitleindex: '',
			formlist: getdata().formlist,
			headobj: {},
			choosecellCode: '',
			smtext: '',
			zcdata: [],
			searchlistzc: getdata().searchlistzc,
			headDatazc: getdata().headDatazc,
			pagination: getdata().pagination,
			seezcformlist: getdata().seezcformlist,
			formdatazc: getdata().formdatazc, //form表单数据
			//表一
			tableDataI_I: [],
			tableDataII_I: {},
			IHead: ['whsy_0_x_1', 'whsy_0_x_2'],
			IIHead: ['whsy_1_x_1', 'whsy_1_x_2', 'whsy_1_x_3', 'whsy_1_x_4', 'whsy_1_x_4a', 'whsy_1_x_5', 'whsy_1_x_6'],
			//表三
			choosetable: '',
			chooseindex: '',
			choosecolum: '',
			delCellsI: []
		};
	},

	methods: {
		//政策点击预览
		zcsclick(id) {
			this.$refs.boxref.zcsclick(id);
		},
		//选中格子
		forhover(table, colum, index) {
			this.$refs.boxref.forhover(table, colum, index);
		},
		//获取选中格子
		getchoosecellCode(table, colum, index) {
			if (this.$emptyandnull(table)) {
				this.choosecellCode = '';
				return false;
			}
			this.choosetable = table;
			this.chooseindex = index;
			this.choosecolum = colum;

			this.choosecellCode = this[table][index][colum].cellCode;
			if (this.toseeUpdate) {
				this.smtext = this[table][index][colum]['map'] ? this[table][index][colum]['map']['desc'] : '';
				this.zcdata = this[table][index][colum]['map'] ? this[table][index][colum]['map']['zcs'] : [];
			} else {
				this.smtext = this[table][index][colum]['updateDesc'] || '';
			}
		},
		//更正说明
		forgengzheng(table, colum, index, smtext) {
			this[table][index][colum]['updateDesc'] = smtext;
		},
		//更正政策和说明
		forxzsm(table, colum, index, smtext, zcdata) {
			this[table][index][colum]['map'] = {
				desc: '',
				zcs: []
			};
			this[table][index][colum]['map']['desc'] = smtext;
			this[table][index][colum]['map']['zcs'] = zcdata;
		},
		//点击全部范围
		refreshhover() {
			this.$nextTick(() => {
				this.$refs.boxref.refreshhover();
			});
		},
		getShuibDetailList() {
			getShuibDetailList({
				shuizId: this.params.shuizId,
				id: this.params.shuibId
			}).then(res => {
				if (res.data.code == 1) {
					this.treedata = res.data.data;
					if (this.treedata[0]) {
						this.getchoosetitleindex(this.treedata[0]);
					}
					this.querycell();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		manuscriptqueryReportStep() {
			manuscriptqueryReportStep({
				id: this.params.id,
				sbbm: this.params.sbbm
			}).then(res => {
				if (res.data.code == 1) {
					this.statedata = res.data.data.statusHistory;
					this.treedata = res.data.data.detail;
					if (this.treedata[0]) {
						this.getchoosetitleindex(this.treedata[0]);
					}
					this.querycell();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		getchoosetitleindex(item) {
			this.choosetitleindex = item.shuibNameCode;
		},
		//表格隐藏显示和返回
		forback() {
			if(this.Changed>0){
					this.$showConfirm({
						message: "是否不保存当前修改?",
						title:"您还未保存",
					}).then((res) => {
						if (res == "confirm") {
							this.$emit('forback', true);
						}else{
							//取消
						}
					});
			}else{
				this.$emit('forback', true);
			}
		},
		changestate(e) {
			this.treestate = e;
		},
		//传给后端值处理
		filternums(data, filterlist) {
			var newlist = [];
			filterlist.forEach(ytem => {
				let newval = data.map(item => {
					if (item[ytem] != undefined && item[ytem] != 'undefined' && this.$notemptyandnull(item[ytem]) && item[ytem].cellVal != '合计') {
						return item[ytem];
					} else {
						return 'x';
					}
				});
				newlist = [...newlist, ...newval].filter(gtem => gtem != 'x');
			});
			return newlist;
		},

		refreshtableDataI() {
			this.tableDataI_I.forEach((item, index) => {
				this.IHead.forEach(gtem => {
					if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem].cellVal != '- -') {
						item[gtem].cellVal = '';
						item[gtem].cellType = '';
					}
				});
			});
		},
		refreshtableDataII() {
			this.tableDataII_I.forEach((item, index) => {
				this.IIHead.forEach(gtem => {
					if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem].cellVal != '- -') {
						item[gtem].cellVal = '';
						item[gtem].cellType = '';
					}
				});
			});
		},
		commanddcrefresh(e) {
				this.Changed++
			if (e == 'all') {
				Object.keys(this.headobj).map(key => (this.headobj[key] = ''));
				this.refreshtableDataI();
				this.refreshtableDataII();
			}
		},
		//所有表格渲染
		querycell(index) {
			//编辑格子查询
			if (this.type == 'update') {
				querycell({
					companyNo: this.params.companyNo, // 公司编号
					id: this.params.id, //报表id
					shuibId: this.params.shuibId, //税种id
					sbbm: this.params.sbbm
				}).then(res => {
					let dataarr = res.data.data;
					this.gettable(dataarr);
				});
			}
			if (this.type == 'tosee') {
				if (this.seeNow) {
					querycell({
						companyNo: this.params.companyNo, // 公司编号
						id: this.params.id, //报表id
						shuibId: this.params.shuibId, //税种id
						sbbm: this.params.sbbm
					}).then(res => {
						let dataarr = res.data.data;
						this.gettable(dataarr);
					});
					return false;
				}
				if (this.toseeUpdate) {
					querytemplatecell({
						shuibId: this.params.shuibId,
						id: this.params.id
					}).then(res => {
						let dataarr = res.data.data;
						this.gettable(dataarr);
					});
				} else {
					reportquerytrack({
						companyNo: this.params.companyNo, // 公司编号
						id: this.params.id, //报表id
						shuibId: this.params.shuibId, //税种id
						sbbm: this.params.sbbm,
						trackId: this.params.trackId
					}).then(res => {
						let dataarr = res.data.data;
						this.gettable(dataarr);
					});
				}
			}
		},

		gettable(dataarr) {
			this.headobj = dataarr.head;
			// this.headobj =getdata().headobj
			// 	this.treedata =getdata().treedata
			// this.tableDataI_I = dataarr.whsy_0

			// this.tableDataI_I = getdataI().tableDataI
			// this.tableDataI_II = getdataI().tableDataII
			// this.tableDataII_I = getdataII().tableDataI
			this.tableDataII_I = dataarr.whsy_1;
			var newtableDataI = dataarr.whsy_0;
			var realtableDataI = getdataI().tableDataI;
			realtableDataI.forEach((item, index) => {
				if (newtableDataI[index]) {
					this.IHead.forEach(gtem => {
						item[gtem] = newtableDataI[index][gtem];
					});
				}
			});
			this.tableDataI_I = realtableDataI;

			// var newtableDatas = dataarr.sdsA_1.filter((item, index) =>index > 1&& index < 5)
			// var realtableDatas= dataI.tableDatas
			// realtableDatas.forEach((item, index) => {
			// 	if (newtableDatas[index]) {
			// 		this.IHead.forEach(gtem => {
			// 			item[gtem] = newtableDatas[index][gtem]
			// 		})
			// 	}
			// })
			// this.tableDatas = realtableDatas
		},
		IdelCellsCode(e) {
			this.delCellsI = [...this.filternums(e, this.IIHead)];
		},
		updataheadobj(e) {
			this.headobj = e;
		},
		headchange(e) {
			this.headobj = e;
		},
		forsave() {
			const newarr = [...this.filternums(this.tableDataI_I, this.IHead), ...this.filternums(this.tableDataII_I, this.IIHead)];
			let params = {
				cells: newarr,
				companyNo: this.params.companyNo,
				delCells: this.delCellsI,
				id: this.params.id,
				sbbm: this.params.sbbm,
				head: this.headobj,
				checkFlag: 'true'
			};
			writesave(params).then(res => {
				if (res.data.code == 1) {
					this.Changed = 0
					this.querycell();
					this.$message.success(res.data.msg);
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		inputblur(e) {
			this.Changed++
			if (
				parseFloat(e.cellVal).toFixed(2) != parseFloat(this[this.choosetable][this.chooseindex][this.choosecolum]['cellOldVal']).toFixed(2) &&
				this[this.choosetable][this.chooseindex][this.choosecolum]['cellCode'] == e.cellCode
			) {
				this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '1';
			}else
			if (
				e.cellVal!= this[this.choosetable][this.chooseindex][this.choosecolum]['cellOldVal'] &&
				this[this.choosetable][this.chooseindex][this.choosecolum]['cellCode'] == e.cellCode
			) {
				this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '1';
			}
			let code =
				e.cellCode.substring(e.cellCode.length - 2, e.cellCode.length - 1) == '_'
					? e.cellCode.substring(e.cellCode.length - 1, e.cellCode.length)
					: e.cellCode.substring(e.cellCode.cellCode.length - 2, e.cellCode.length - 1);
			let num =
				e.cellCode.substring(e.cellCode.length - code.length - 3, e.cellCode.length - code.length - 2) == '_'
					? e.cellCode.substring(e.cellCode.length - code.length - 2, e.cellCode.length - code.length - 1)
					: e.cellCode.substring(e.cellCode.length - code.length - 3, e.cellCode.length - code.length - 2);
			if (code == 6) {
				this.whsy_1_1000_6();
			}
			if (e.cellCode == 'whsy_0_1_1') {
				this.changetableval('whsy_0_1_2', 'tableDataI_I', this.gettableval('whsy_0_1_2', 'tableDataI_I', 'old') + this.gettableval('whsy_0_1_1', 'tableDataI_I'));
				this.changetableval('whsy_0_8_1', 'tableDataI_I', this.gettableval('whsy_0_1_1', 'tableDataI_I') - this.gettableval('whsy_0_5_1', 'tableDataI_I'));
			}
			if (e.cellCode == 'whsy_0_2_1') {
				this.changetableval('whsy_0_2_2', 'tableDataI_I', this.gettableval('whsy_0_2_2', 'tableDataI_I', 'old') + this.gettableval('whsy_0_2_1', 'tableDataI_I'));
			}
			if (e.cellCode == 'whsy_0_3_1') {
				this.changetableval('whsy_0_3_1', 'tableDataI_I', this.gettableval('whsy_0_7_1', 'tableDataI_I', 'old'));
				this.changetableval(
					'whsy_0_7_1',
					'tableDataI_I',
					this.gettableval('whsy_0_3_1', 'tableDataI_I') +
						this.gettableval('whsy_0_4_1', 'tableDataI_I') +
						this.gettableval('whsy_0_5_1', 'tableDataI_I') +
						this.gettableval('whsy_0_6_1', 'tableDataI_I')
				);
			}
			if (e.cellCode == 'whsy_0_4_1') {
				this.changetableval('whsy_0_4_2', 'tableDataI_I', this.gettableval('whsy_0_4_2', 'tableDataI_I', 'old') + this.gettableval('whsy_0_4_1', 'tableDataI_I'));
				this.changetableval(
					'whsy_0_7_1',
					'tableDataI_I',
					this.gettableval('whsy_0_3_1', 'tableDataI_I') +
						this.gettableval('whsy_0_4_1', 'tableDataI_I') +
						this.gettableval('whsy_0_5_1', 'tableDataI_I') +
						this.gettableval('whsy_0_6_1', 'tableDataI_I')
				);
			}
			if (e.cellCode == 'whsy_0_5_1') {
				this.changetableval('whsy_0_5_2', 'tableDataI_I', this.gettableval('whsy_0_5_2', 'tableDataI_I', 'old') + this.gettableval('whsy_0_5_1', 'tableDataI_I'));
				this.changetableval(
					'whsy_0_7_1',
					'tableDataI_I',
					this.gettableval('whsy_0_3_1', 'tableDataI_I') +
						this.gettableval('whsy_0_4_1', 'tableDataI_I') +
						this.gettableval('whsy_0_5_1', 'tableDataI_I') +
						this.gettableval('whsy_0_6_1', 'tableDataI_I')
				);
				this.changetableval('whsy_0_8_1', 'tableDataI_I', this.gettableval('whsy_0_1_1', 'tableDataI_I') - this.gettableval('whsy_0_5_1', 'tableDataI_I'));
			}
			if (e.cellCode == 'whsy_0_6_1') {
				this.changetableval('whsy_0_6_2', 'tableDataI_I', this.gettableval('whsy_0_6_2', 'tableDataI_I', 'old') + this.gettableval('whsy_0_6_1', 'tableDataI_I'));
				this.changetableval(
					'whsy_0_7_1',
					'tableDataI_I',
					this.gettableval('whsy_0_3_1', 'tableDataI_I') +
						this.gettableval('whsy_0_4_1', 'tableDataI_I') +
						this.gettableval('whsy_0_5_1', 'tableDataI_I') +
						this.gettableval('whsy_0_6_1', 'tableDataI_I')
				);
			}
			if (e.cellCode == 'whsy_0_7_1') {
				this.changetableval('whsy_0_7_2', 'tableDataI_I', this.gettableval('whsy_0_7_2', 'tableDataI_I', 'old') + this.gettableval('whsy_0_7_1', 'tableDataI_I'));
			}
			if (e.cellCode == 'whsy_0_8_1') {
				this.changetableval('whsy_0_8_2', 'tableDataI_I', this.gettableval('whsy_0_8_2', 'tableDataI_I', 'old') + this.gettableval('whsy_0_8_1', 'tableDataI_I'));
				this.changetableval('whsy_0_10_1', 'tableDataI_I', this.gettableval('whsy_0_8_1', 'tableDataI_I') * this.gettableval('whsy_0_9_1', 'tableDataI_I'));
			}
			if (e.cellCode == 'whsy_0_9_1') {
				this.changetableval('whsy_0_10_1', 'tableDataI_I', this.gettableval('whsy_0_8_1', 'tableDataI_I') * this.gettableval('whsy_0_9_1', 'tableDataI_I'));
			}
			if (e.cellCode == 'whsy_0_10_1') {
				this.changetableval('whsy_0_10_2', 'tableDataI_I', this.gettableval('whsy_0_10_2', 'tableDataI_I', 'old') + this.gettableval('whsy_0_10_1', 'tableDataI_I'));
				this.changetableval(
					'whsy_0_16_1',
					'tableDataI_I',
					this.gettableval('whsy_0_10_1', 'tableDataI_I') + this.gettableval('whsy_0_11_1', 'tableDataI_I') - this.gettableval('whsy_0_12_1', 'tableDataI_I')
				);
			}
			if (e.cellCode == 'whsy_0_11_1') {
				this.changetableval(
					'whsy_0_16_1',
					'tableDataI_I',
					this.gettableval('whsy_0_10_1', 'tableDataI_I') + this.gettableval('whsy_0_11_1', 'tableDataI_I') - this.gettableval('whsy_0_12_1', 'tableDataI_I')
				);
				this.changetableval(
					'whsy_0_17_1',
					'tableDataI_I',
					this.gettableval('whsy_0_11_1', 'tableDataI_I') - this.gettableval('whsy_0_14_1', 'tableDataI_I') - this.gettableval('whsy_0_15_1', 'tableDataI_I')
				);
			}
			if (e.cellCode == 'whsy_0_16_1') {
				this.changetableval('whsy_0_16_2', 'tableDataI_I', this.gettableval('whsy_0_16_2', 'tableDataI_I', 'old') + this.gettableval('whsy_0_16_1', 'tableDataI_I'));
			}
			if (e.cellCode == 'whsy_0_19_1') {
				this.changetableval('whsy_0_19_2', 'tableDataI_I', this.gettableval('whsy_0_19_2', 'tableDataI_I', 'old') + this.gettableval('whsy_0_19_1', 'tableDataI_I'));
			}
			if (e.cellCode == 'whsy_0_12_1') {
				this.changetableval('whsy_0_12_2', 'tableDataI_I', this.gettableval('whsy_0_12_2', 'tableDataI_I', 'old') + this.gettableval('whsy_0_12_1', 'tableDataI_I'));
				this.changetableval(
					'whsy_0_16_1',
					'tableDataI_I',
					this.gettableval('whsy_0_10_1', 'tableDataI_I') + this.gettableval('whsy_0_11_1', 'tableDataI_I') - this.gettableval('whsy_0_12_1', 'tableDataI_I')
				);
			}
			if (e.cellCode == 'whsy_0_13_1') {
				this.changetableval(
					'whsy_0_12_1',
					'tableDataI_I',
					this.gettableval('whsy_0_13_2', 'tableDataI_I') + this.gettableval('whsy_0_14_1', 'tableDataI_I') + this.gettableval('whsy_0_15_1', 'tableDataI_I')
				);
				this.changetableval('whsy_0_13_2', 'tableDataI_I', this.gettableval('whsy_0_13_1', 'tableDataI_I', 'old') + this.gettableval('whsy_0_13_1', 'tableDataI_I'));
			}
			if (e.cellCode == 'whsy_0_14_1') {
				this.changetableval(
					'whsy_0_12_1',
					'tableDataI_I',
					this.gettableval('whsy_0_13_2', 'tableDataI_I') + this.gettableval('whsy_0_14_1', 'tableDataI_I') + this.gettableval('whsy_0_15_1', 'tableDataI_I')
				);
				this.changetableval('whsy_0_14_2', 'tableDataI_I', this.gettableval('whsy_0_14_1', 'tableDataI_I', 'old') + this.gettableval('whsy_0_14_1', 'tableDataI_I'));
				this.changetableval(
					'whsy_0_17_1',
					'tableDataI_I',
					this.gettableval('whsy_0_11_1', 'tableDataI_I') - this.gettableval('whsy_0_14_1', 'tableDataI_I') - this.gettableval('whsy_0_15_1', 'tableDataI_I')
				);
			}
			if (e.cellCode == 'whsy_0_15_1') {
				this.changetableval(
					'whsy_0_12_1',
					'tableDataI_I',
					this.gettableval('whsy_0_13_2', 'tableDataI_I') + this.gettableval('whsy_0_14_1', 'tableDataI_I') + this.gettableval('whsy_0_15_1', 'tableDataI_I')
				);
				this.changetableval('whsy_0_15_2', 'tableDataI_I', this.gettableval('whsy_0_15_1', 'tableDataI_I', 'old') + this.gettableval('whsy_0_15_1', 'tableDataI_I'));
				this.changetableval(
					'whsy_0_17_1',
					'tableDataI_I',
					this.gettableval('whsy_0_11_1', 'tableDataI_I') - this.gettableval('whsy_0_14_1', 'tableDataI_I') - this.gettableval('whsy_0_15_1', 'tableDataI_I')
				);
			}
			this.changetableval('whsy_0_9_1', 'tableDataI_I', 3);
		},
		// old
		whsy_1_1000_6() {
			let total = 0;
			this.tableDataII_I.map(item => {
				Object.keys(item).map(key => {
					let Code = key.substring(key.length - 2, key.length - 1) == '_' ? key.substring(key.length - 1, key.length) : key.substring(key.length - 2, key.length - 1);
					if (Code == 6 && item[key].cellCode != 'whsy_1_1000_6') {
						total += this.gettableval(`${item[key].cellCode}`, 'tableDataII_I');
					}
				});
			});
			this.changetableval(`whsy_1_1000_6`, 'tableDataII_I', total);
		},
		gettableval(changecode, table, old) {
			var head = '';
			if (table == 'tableDataII_I') {
				head = 'IIHead';
			}else if (table == 'tableDataI_I') {
				head = 'IHead';
			}

			var a;
			if (this[table] && this[head]) {
				for (let i = 0; i < this[table].length; i++) {
					for (let j = 0; j < this[head].length; j++) {
						if (
							this[table][i][this[head][j]] &&
							this[table][i][this[head][j]].cellCode &&
							this[table][i][this[head][j]].cellVal &&
							this[table][i][this[head][j]].cellCode == changecode
						) {
							if (old) {
								if (this.$emptyandnull(this[table][i][this[head][j]].goujgxValue)) {
									a = 0;
								} else {
									a = parseFloat(this[table][i][this[head][j]].goujgxValue);
								}
							} else {
								if (this[table][i][this[head][j]].cellVal == '-') {
									a = 0;
								} else {
									a = parseFloat(this[table][i][this[head][j]].cellVal || 0);
								}
							}
							break;
						}
					}
				}
			}
			a = a || 0;
			if (changecode == 'sdsA_1_18_1' || changecode == 'sdsA_1_19_1' || changecode == 'sdsA_1_20_1' || changecode == 'sdsA_1_20_2' || changecode == 'sdsA_1_23.2_2') {
				if (!a < 1) {
					a = a * 0.01;
				}
			}
			return a;
		},
		changetableval(changecode, table, newval, checkq) {
			var newval = newval || 0;
			newval = this.toFixed(newval, 2);
			var head = '';
			if (table == 'tableDataII_I') {
				head = 'IIHead';
			}else if (table == 'tableDataI_I') {
				head = 'IHead';
			}
			for (let i = 0; i < this[table].length; i++) {
				for (let j = 0; j < this[head].length; j++) {
					if (
						this[table][i][this[head][j]] &&
						this[table][i][this[head][j]].cellCode &&
						typeof this[table][i][this[head][j]].cellVal != 'undefined' &&
						typeof this[table][i][this[head][j]].cellVal != undefined &&
						this[table][i][this[head][j]].cellCode == changecode
					) {
						if (this[table][i][this[head][j]].cellVal != newval) {
							if (this.suosq.substring(4, 6) < 5 && checkq) {
								this[table][i][this[head][j]].cellVal = '';
							} else {
								this[table][i][this[head][j]].cellVal = newval + '';
							}
							this.inputblur({
								cellCode: changecode,
								cellVal: newval
							});
							break;
						}
					}
				}
			}
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
